/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import { atom } from 'jotai'

/** The structure for the session atom. */
type Geolocation = {
  /** ISO 3166-1 alpha-2 country code. */
  country?: string

  /** The name of the city. */
  city?: string
}

// Atom for the user's geolocation
const geolocationAtom = atom<Geolocation | undefined>(undefined)
geolocationAtom.debugLabel = 'geolocationAtom'

export { geolocationAtom }
export type { Geolocation }
